import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CityPhone = styled.a`
    ${FONTS.MediumXXS};
    color: ${COLORS.GRAY_DARK};
    text-decoration: none;
    white-space: nowrap;
    transition: 0.3s color ease;

    &:hover {
        color: ${COLORS.TextPrimary};
    }


    @media (max-width: ${wideBreakpoints.laptop}) {
        color: ${COLORS.TextPrimary};
    }  
`;
